import { UntypedFormGroup } from '@angular/forms';
import { Section } from 'classes-lib';
import { ISection } from 'interfaces-lib';

/**
 * Should be extended by any Section Component that needs to include additional FormControls
 */
export abstract class SectionComponentBase {
  /**
   * Build on the base form by adding specific section FormControls
   * @param formGroup the FormGroup that represents this section. Add specific section related FormControls to this group.
   * @param section the section data.
   */
  protected static buildForm(formGroup: UntypedFormGroup, section?: ISection): void {}

  /**
   * Parses the FormGroup value into a specific Section. Derived Section Components will know how to interpret the FormGroup
   * to return the correct Section instance.
   * @param formGroup represents the Section elements
   * NOTE: this was intended to be used in the workflow-config component saveWorkflowConfig(..) but is not currently used.
   */
  protected static parseForm(formGroup: UntypedFormGroup): Section {
    throw Error('NotImplementedException');
  }
}
